import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from '../../logo.svg';
import UserWidget from "../user/user-widget";
import { MainMenu } from "./main-menu";
import { UserNotifications } from "../user/user-notifications";

export default function Header() {
    const { t } = useTranslation();

    return (
        <header>
            <Container>
                <Row>
                    <Col>
                        <div className="header-content">
                            <Link className="branding" to="/" title={ t("go_home")}>
                                <img alt="Badminton" src= {logo}/>
                            </Link>

                            <div className="user-bar">
                                <UserWidget /> 
                                <UserNotifications />
                                <MainMenu />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </header>
    );
}